// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ((chunkId === 904 ? "lazyStandardReportPromptsRoute" : chunkId) + "." + chunkId + ".reporting-app.css");